import { isEnum } from './isEnum'

export enum InspectionType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export const isInspectionType = isEnum<InspectionType>(InspectionType)
